import React from "react";
import { formatEuro, formatKm } from "./formatters";
import styles from "./DossierDashboard.module.scss";

const DurKmMatrix = ({ stats, filters, onToggleDurKm }) => {
  const { durations, kms, cells, maxCellCount } = stats.durKm;
  if (cells.length < 2) return null;
  const cellFor = (dur, km) =>
    cells.find((c) => c.dur === dur && c.km === km);
  return (
    <div className={styles.sect}>
      <div className={styles.sectTitle}>
        <span>Couverture durée × km</span>
      </div>
      <div
        className={styles.matrix}
        style={{ gridTemplateColumns: `repeat(${kms.length}, 1fr)` }}
      >
        {durations.map((dur) =>
          kms.map((km) => {
            const cell = cellFor(dur, km);
            if (!cell) {
              return (
                <div
                  key={dur + "-" + km}
                  className={`${styles.matrixCell} ${styles.matrixCellEmpty}`}
                >
                  {dur}m / {formatKm(km)}
                  <b>—</b>
                </div>
              );
            }
            const isActive =
              filters.duration === String(dur) && filters.km === String(km);
            const isHot =
              maxCellCount > 1 && cell.count === maxCellCount;
            return (
              <button
                key={dur + "-" + km}
                type="button"
                className={`${styles.matrixCell} ${
                  isHot ? styles.matrixCellHot : ""
                } ${isActive ? styles.matrixCellActive : ""}`}
                onClick={() => onToggleDurKm(dur, km)}
                title={`${cell.count} devis — filtrer la liste`}
              >
                {dur}m / {formatKm(km)}
                <b>{formatEuro(cell.avgRentHT)}</b>
              </button>
            );
          })
        )}
      </div>
      <div className={styles.note}>
        loyer HT moyen par combinaison · case vide = non chiffré · clic →
        filtre durée/km
      </div>
    </div>
  );
};

export default DurKmMatrix;
